import { useCallback, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { MainContext } from "../context/main";

export default function useNavLinks() {
  const location = useLocation();
  const { mainDispatch } = useContext(MainContext);

  const updateNavButtons = useCallback(
    ({ nextCurrentPost, showEditButton = false, hideAll = false }) => {
      if (hideAll) {
        mainDispatch({
          type: "MAIN_SET_NAV_BUTTONS",
          navButtons: [],
        });
        return;
      }

      const navButtons =
        (nextCurrentPost.path === "/wiki" ||
          location.pathname.substring(0, 5) === "/edit") &&
        !showEditButton
          ? []
          : [
              <Link key={"edit-link"} to={`/edit/${nextCurrentPost.id}`}>
                <button>Edit</button>
              </Link>,
            ];
      if (nextCurrentPost.isPublic) {
        navButtons.push(
          <Link key={"public-link"} to={`/public/${nextCurrentPost.id}`}>
            <button>Public Link</button>
          </Link>
        );
      }

      mainDispatch({
        type: "MAIN_SET_NAV_BUTTONS",
        navButtons,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return { updateNavButtons };
}
